import type { BaremetalServer } from '@/entities/baremetal';
import request from '@/shared/api/request';

export const reinstallBaremetalServer = (
  id: number,
  kickstart: string,
): Promise<{ baremetal: BaremetalServer }> =>
  request({
    url: `/baremetals/${id}/`,
    method: 'POST',
    data: { kickstart, action: 'rebuild' },
  });
